export function initErrorReportBlocks() {
    const blocks = [].slice.call(document.querySelectorAll('[data-block="ErrorReport"]'));
    blocks.forEach(initErrorReportInstance);
}

export function initErrorReportInstance(root) {
    const headers = [].slice.call(root.querySelectorAll('.-card-title'));
    matchHeight(headers);

    window.addEventListener('resize', () => {
        matchHeight(headers);
    });

    function matchHeight(items) {
        let maxHeight = 0;

        items.forEach((el) => {
            if (el.clientHeight > maxHeight) {
                maxHeight = el.clientHeight;
            }
        });

        items.forEach((el) => {
            el.style.height = maxHeight + 'px';
        });

    }
}
